import 'antd/dist/antd.css';
import './style';
import App from './components/app';
import { makeServer } from './server';

makeServer({ environment: 'development' });

export default App;
